import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private readonly STORAGE_KEY = 'nw-hub-theme';
  private storage = inject(StorageService);
  isDark = true;

  init(): void {
    this.isDark = this.storage.getString(this.STORAGE_KEY) !== 'light';
    this.applyTheme();
  }

  toggle(): void {
    this.isDark = !this.isDark;
    this.storage.setString(this.STORAGE_KEY, this.isDark ? 'dark' : 'light');
    this.applyTheme();
  }

  private applyTheme(): void {
    document.documentElement.classList.toggle('light-theme', !this.isDark);
  }
}
